import Modal from 'bootstrap/js/dist/modal';

export function initQuoteModal() {
  const quoteModalEl = document.getElementById('VraagOfferte');
  const quoteLinks = document.querySelectorAll('a[href="#VraagOfferte"]');
  const quoteForm = document.getElementById('QuoteModalForm');

  if (quoteModalEl && !quoteModalEl.__modalInst) {
    quoteModalEl.__modalInst = Modal.getOrCreateInstance(quoteModalEl);
  }

  quoteLinks.forEach((link) => {
    if (link.__quoteBound) return;
    link.__quoteBound = true;

    link.addEventListener('click', (e) => {
      e.preventDefault();

      const productTitle = link.getAttribute('data-product-title');
      if (productTitle && quoteModalEl) {
        // Clear all checkboxes first
        const checkboxes = quoteModalEl.querySelectorAll('.form-check-input[type="checkbox"]');
        checkboxes.forEach((cb) => {
          cb.checked = false;
        });

        // Try to match the checkbox by value
        const normalizedTitle = productTitle.toLowerCase().replace(/[^a-z0-9]/g, '');
        for (const cb of checkboxes) {
          const val = cb.value.toLowerCase();
          const normalizedVal = val.replace(/[^a-z0-9]/g, '');
          if (normalizedTitle.includes(normalizedVal) || normalizedVal.includes(normalizedTitle)) {
            cb.checked = true;
            break; // Match first one
          }
        }
      }

      quoteModalEl?.__modalInst?.show();
      try {
        sessionStorage.setItem('quoteModalOpen', 'true');
      } catch (err) {
        console.warn('sessionStorage unavailable', err);
      }
    });
  });

  if (quoteForm && !quoteForm.__quoteNativeBound) {
    quoteForm.__quoteNativeBound = true;

    const quoteTabs = quoteForm.querySelectorAll('.quote-tabs .nav-link');
    const discountMsgEl = document.getElementById('quote-discount-msg');

    const updateDiscountMsg = () => {
      if (!discountMsgEl) return;
      const checkedRadio = quoteForm.querySelector('[name="quote_quantity"]:checked');
      if (checkedRadio && checkedRadio.value === '26+') {
        discountMsgEl.classList.remove('d-none');
      } else {
        discountMsgEl.classList.add('d-none');
      }
    };

    quoteTabs.forEach((tab) => {
      if (tab.__tabBound) return;
      tab.__tabBound = true;

      tab.addEventListener('click', () => {
        quoteTabs.forEach((item) => item.classList.remove('active'));
        tab.classList.add('active');
        setTimeout(updateDiscountMsg, 0);
      });
    });

    quoteForm.querySelectorAll('[name="quote_quantity"]').forEach((radio) => {
      radio.addEventListener('change', updateDiscountMsg);
    });

    quoteModalEl?.addEventListener('show.bs.modal', () => {
      setTimeout(updateDiscountMsg, 50);
    });

    updateDiscountMsg();

    quoteForm.addEventListener('submit', function () {
      const bodyInput = quoteForm.querySelector('#QuoteModalBody');
      const noteInput = quoteForm.querySelector('#QuoteModalNote');

      const company = quoteForm.querySelector('[name="contact[company]"]')?.value?.trim() || '';
      const vat = quoteForm.querySelector('[name="contact[vat]"]')?.value?.trim() || '';
      const email = quoteForm.querySelector('[name="contact[email]"]')?.value?.trim() || '';
      const phone = quoteForm.querySelector('[name="contact[phone]"]')?.value?.trim() || '';
      const quantity = quoteForm.querySelector('[name="quote_quantity"]:checked')?.value || '';
      const laptopModel = quoteForm.querySelector('[name="contact[laptop_model]"]')?.value?.trim() || '';

      const groupedSelections = {};

      quoteForm.querySelectorAll('.form-check-input[type="checkbox"]:checked').forEach((input) => {
        const group = input.dataset.group || 'Options';
        if (!groupedSelections[group]) groupedSelections[group] = [];
        groupedSelections[group].push(input.value);
      });

      const selectionLines = Object.entries(groupedSelections)
        .map(([group, values]) => `${group}: ${values.join(', ')}`)
        .join('\n');

      const message = [
        'Quotation Request',
        '',
        `Company: ${company}`,
        `VAT: ${vat}`,
        `Email: ${email}`,
        `Phone: ${phone}`,
        `Quantity: ${quantity || 'Not selected'}`,
        `Laptop Model: ${laptopModel || 'Not provided'}`,
        '',
        'Selections:',
        selectionLines || 'None',
      ].join('\n');

      if (bodyInput) bodyInput.value = message;

      try {
        sessionStorage.setItem('quoteModalSubmitted', 'true');
        sessionStorage.setItem('quoteModalOpen', 'true');
        sessionStorage.setItem('quoteModalEmail', email);
        sessionStorage.setItem('quoteModalSuccessText', 'Bedankt! Je bericht is succesvol verzonden. We nemen zo snel mogelijk contact met je op.');

        const returnUrl = `${window.location.pathname}?quote_sent=1#VraagOfferte`;
        if (noteInput) noteInput.value = returnUrl;
      } catch (err) {
        console.warn('sessionStorage unavailable', err);
      }

    });
  }

  const url = new URL(window.location.href);
  const hasQuoteSent = url.searchParams.get('quote_sent') === '1';
  const hasHash = window.location.hash === '#VraagOfferte' || window.location.hash === '#QuoteModalForm';
  const hasSuccessInDom = !!document.querySelector('#QuoteModalForm [data-quote-feedback="success"]');
  const hasErrorInDom = !!document.querySelector('#QuoteModalForm [data-quote-feedback="error"]');

  let shouldReopen = false;
  let successFallback = false;

  try {
    const wasOpen = sessionStorage.getItem('quoteModalOpen') === 'true';
    const wasSubmitted = sessionStorage.getItem('quoteModalSubmitted') === 'true';
    const isQuoteSubmission = wasSubmitted || hasHash;

    shouldReopen = (hasSuccessInDom && isQuoteSubmission) || (hasErrorInDom && isQuoteSubmission) || (hasQuoteSent && isQuoteSubmission) || (wasOpen && hasHash);
    successFallback = !hasSuccessInDom && !hasErrorInDom && (hasQuoteSent || wasSubmitted);
  } catch (err) {
    shouldReopen = (hasSuccessInDom && hasHash) || (hasErrorInDom && hasHash) || (hasQuoteSent && hasHash) || hasHash;
    successFallback = !hasSuccessInDom && !hasErrorInDom && hasQuoteSent;
  }

  if (quoteModalEl && shouldReopen) {
    quoteModalEl.__modalInst?.show();

    if (quoteForm && successFallback) {
      const existing = quoteForm.querySelector('.alert.alert-success[data-fallback-success="true"]');
      if (!existing) {
        const successText =
          quoteForm.querySelector('#QuoteModalSuccessMsg')?.value ||
          'Bedankt! Je bericht is succesvol verzonden. We nemen zo snel mogelijk contact met je op.';

        const msg = document.createElement('div');
        msg.className = 'alert alert-success mt-3';
        msg.setAttribute('data-fallback-success', 'true');
        msg.textContent = successText;

        const formWrap = quoteForm.querySelector('.contact-form') || quoteForm;
        const buttonWrap = formWrap.querySelector('.text-center');
        if (buttonWrap) {
          buttonWrap.insertAdjacentElement('afterend', msg);
        } else {
          formWrap.appendChild(msg);
        }
      }

      const inputsToClear = quoteForm.querySelectorAll(
        'input[type="text"], input[type="email"], input[type="tel"], textarea'
      );
      inputsToClear.forEach((input) => {
        if (
          input.name === 'contact[body]' ||
          input.name === 'contact[form_title]' ||
          input.name === 'contact[modal_form]' ||
          input.name === 'contact[tags]' ||
          input.name === 'contact[note]'
        ) {
          return;
        }
        input.value = '';
      });

      quoteForm.querySelectorAll('.form-check-input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });

      const radios = quoteForm.querySelectorAll('[name="quote_quantity"]');
      const tabs = quoteForm.querySelectorAll('.quote-tabs .nav-link');
      radios.forEach((radio, index) => {
        radio.checked = index === 0;
      });
      tabs.forEach((tab, index) => {
        tab.classList.toggle('active', index === 0);
      });
      if (typeof updateDiscountMsg === 'function') {
        updateDiscountMsg();
      }
    }

    try {
      sessionStorage.removeItem('quoteModalOpen');
      sessionStorage.removeItem('quoteModalSubmitted');
      sessionStorage.removeItem('quoteModalEmail');
      sessionStorage.removeItem('quoteModalSuccessText');
    } catch (err) {
      console.warn('sessionStorage unavailable', err);
    }

    if (hasQuoteSent) {
      url.searchParams.delete('quote_sent');
      const cleanUrl = `${url.pathname}${url.search ? `?${url.searchParams.toString()}` : ''}${window.location.hash || ''}`;
      window.history.replaceState({}, '', cleanUrl);
    }
  }
    initQuoteBannerSync();
}

function initQuoteBannerSync() {
  const banners = document.querySelectorAll('[data-quote-banner-options]');
  const quoteModalEl = document.getElementById('VraagOfferte');

  banners.forEach((banner) => {
    const labels = banner.querySelectorAll('.quote-volume-banner__option');
    const radios = banner.querySelectorAll('.quote-volume-banner__radio');

    const updateActiveState = () => {
      labels.forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        label.classList.toggle('is-active', !!input?.checked);
      });
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', updateActiveState);
    });

    updateActiveState();
  });

  document.querySelectorAll('[data-open-quote-modal]').forEach((trigger) => {
    if (trigger.__quoteBannerBound) return;
    trigger.__quoteBannerBound = true;

    trigger.addEventListener('click', () => {
      const section = trigger.closest('.quote-volume-banner');
      if (!section || !quoteModalEl) return;

      const selectedRadio = section.querySelector('.quote-volume-banner__radio:checked');
      if (!selectedRadio) return;

      const modalRadios = quoteModalEl.querySelectorAll('input[name="quote_quantity"]');
      const modalTabs = quoteModalEl.querySelectorAll('.quote-tabs .nav-link');

      modalRadios.forEach((radio) => {
        radio.checked = radio.value.trim() === selectedRadio.value.trim();
      });

      modalTabs.forEach((tab) => {
        const input = tab.querySelector('input[name="quote_quantity"]');
        tab.classList.toggle('active', !!input?.checked);
      });
    });
  });
}